var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert-mode fade-in"},[_c('span',[_vm._v(_vm._s(_vm.textAlert))]),_c('i',{staticClass:"fas fa-exclamation-triangle"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }